define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Util, Component) => {
  const { classNames } = Util;

  const VALID_STYLE_ATTRS = [
    'color',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'borderTopWidth',
    'borderLeftWidth',
    'borderBottomWidth',
    'borderRightWidth',
    'borderColor',
    'borderStyle',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'lineHeight',
    'boxShadow',
    'textShadow',
  ];

  @Component({ disableVerticalResize: true })
  class Radio extends React.Component {
    static propTypes = {
      label: PropTypes.string,
      options: PropTypes.object,
      style: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    }

    constructor(props) {
      super(props);

      this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
      const { name, onChangeForm } = this.props;

      if (onChangeForm) onChangeForm({ [name]: e.currentTarget.value });
    }

    getChildStyle() {
      return _.pick(this.props.style.toJS(), 'color');
    }

    renderRadioButtons() {
      const {
        name,
        options,
        defaultValue,
        onFocus,
        onBlur,
      } = this.props;
      const radioButtons = [];
      const containerStyle = _.extend({ margin: '0', display: 'block' }, this.getChildStyle());

      options.forEach(option => {
        const id = option.get('id');
        const label = option.get('label');
        const value = option.get('value');

        radioButtons.push(
          <label key={id} style={containerStyle}>
            <input
              type="radio"
              name={name}
              value={value}
              defaultChecked={value === defaultValue}
              onChange={this.onChange}
              onFocus={onFocus}
              onBlur={onBlur}
            />
            <span style={{ paddingLeft: '8px' }}>{label}</span>
          </label>
        );
      });

      return radioButtons;
    }

    render() {
      const {
        isPreview,
        label,
        onMouseEnter,
        onMouseLeave,
      } = this.props;
      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);
      style.textAlign = 'center'; // center the group in the container
      style.padding = '0';
      style.margin = '0';
      style.display = 'block';
      style.width = '100%';

      const className = classNames(
        'sumome-react-label-style',
        { 'sumome-react-wysiwyg-overlay': isPreview },
      );

      return (
        <div
          ref={(el) => this.textEl = el}
          className={className}
          style={style}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <label style={this.getChildStyle()}>{label}</label>
          {this.renderRadioButtons()}
        </div>
      );
    }
  }

  return Radio;
});

